module.exports = __webpack_public_path__ + "static/media/event.2f257505.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Home/event.png
// module id = 235
// module chunks = 0